// Runtime value wins (injected at container start via env-config.js, see
// env-config.js.template + Dockerfile CMD) — lets Cloud Run env vars toggle
// this without an image rebuild. Falls back to the build-time REACT_APP_*
// var for local `npm start` (no nginx/env-config.js there). Default OFF.
const runtimeValue = (typeof window !== 'undefined' && window.__RUNTIME_ENV__?.WHATSAPP_ENABLED)
    || process.env.REACT_APP_WHATSAPP_ENABLED;

export const WHATSAPP_ENABLED = runtimeValue === 'true' || runtimeValue === '1';
